import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk, { ThunkDispatch } from "redux-thunk";
import {
  useSelector as reduxUseSelector,
  useDispatch as reduxUseDispatch
} from "react-redux";
import { AppActions, AppState, rootReducer } from "../reducers/index";

const composeEnhancers = composeWithDevTools({});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export const useSelector = <TSelector>(selector: (state: AppState) => TSelector) => reduxUseSelector(selector);
export const useDispatch = () => reduxUseDispatch<typeof store["dispatch"]>() as ThunkDispatch<AppState, void, AppActions>;

export type AppDispatchType = typeof store.dispatch;

export default store;
